import { CarouselProvider, Slide, Slider } from "pure-react-carousel";
import { useEffect, useRef, useState } from "react";
import useWindowSize from "../../hooks/useWindowSize";


const CarouselSlider = ({ CATEGS, CategoryCard }: any) => {
    return (
        <Slider >
            {
                CATEGS.map((categ: any, key: any) => (
                    <Slide index={key} key={key}>
                        <CategoryCard bgIm={categ.bgIm} title={categ.title} desc={categ.desc} url={categ.url}/>
                    </Slide>
                ))
            }
        </Slider>
    );
};

const CategoriesSlider= ({CATEGS, CategoryCard}: any) => {
    const spaceBetweenSlides= 25;
    const slideSizesInX= 285;
    const w= useWindowSize();
    const [carouselContainerSize, setCarouselContainerSize]= useState(0);
    const carouselContainerRef= useRef<HTMLDivElement>(null);
    const [slidesToShow, setSlidesToShow]= useState((carouselContainerSize + spaceBetweenSlides) / (slideSizesInX + spaceBetweenSlides));
    
    useEffect(()=>{
        const windowResizeHandler= () =>{
            if(carouselContainerRef.current){
                setCarouselContainerSize(carouselContainerRef.current.offsetWidth);
            }
        };
        window.addEventListener("resize", windowResizeHandler);
        window.dispatchEvent(new Event("resize"));//<- This has to be here otherwise the logic breaks because slidesToShow is calculated when carouselContainerSize is 0 and is never updated afterwards. So manually firing the resize event forces a recalculation with the correct values.
        return ()=> {
            window.removeEventListener("resize", windowResizeHandler);
        };
    },[]);

    useEffect(()=> {
        if(carouselContainerRef.current!== null){
            setSlidesToShow((carouselContainerSize + spaceBetweenSlides) / (slideSizesInX + spaceBetweenSlides));
        } else {
            setSlidesToShow((w + spaceBetweenSlides) / (slideSizesInX + spaceBetweenSlides));
        }
    },[carouselContainerSize, w]);

    return (<>
        <div className="w-full overflow-hidden mt-[3rem]">
            <div className="md:w-4/5 w-4/5 mx-auto no-clip-slider max-w-[1144px]" ref={carouselContainerRef}>
                <CarouselProvider visibleSlides={slidesToShow} totalSlides={12} naturalSlideHeight={470} naturalSlideWidth={285} isIntrinsicHeight={true} step={1} >
                    <CarouselSlider CATEGS={CATEGS} CategoryCard={CategoryCard}/>
                </CarouselProvider>
            </div>
        </div>
    </>);
};

export default CategoriesSlider;